/**
 *账号管理 vm
 *@author xujinjiang
 *@date 2022/3/1 17:38
 */
import { BaseViewModel } from '@/viewmodel/BaseViewModel';
import { AcountManageServiceImpl } from '@/service/AcountManageServiceImpl';
import { LocalStorageManager } from '@/db/LocalStorageManager';
import 'element-plus/theme-chalk/el-message.css';
import { AuditLogServiceImpl } from '@/service/AuditLogServiceImpl';
import { actionType } from '@/constant/ActionType';
import { CommonUtil } from '@/utils/CommonUtil';
export class ManageViewModel extends BaseViewModel {
  dialogFormVisible: any = false;
  isShowLoadingBtn = false;
  formLabelWidth = 120;

  userInfo = {
    name: '',
    email: '',
    id: ''
  };

  form = {
    oldPassword: '',
    password: '',
    confirmPassword: ''
  };

  rules = {
    oldPassword: [
      {
        required: true,
        validator: this.checkOldPassword.bind(this),
        trigger: 'blur'
      }
    ],
    password: [{ required: true, validator: this.password.bind(this), trigger: 'blur' }],
    confirmPassword: [
      {
        required: true,
        validator: this.checkPassword.bind(this),
        trigger: 'blur'
      }
    ]
  };

  created() {
    const user: any = LocalStorageManager.getUser();
    this.userInfo.id = user.id;
    this.userInfo.name = user.name;
    this.userInfo.email = user.email;
  }

  modifyPassword() {
    this.dialogFormVisible = true;
  }

  closeDialog() {
    (this.$refs['ruleFormRef'] as any).resetFields();
    this.dialogFormVisible = false;
    this.isShowLoadingBtn = false;
  }

  async checkOldPassword(rule: any, value: any, callback: any) {
    if (!value) {
      return callback(new Error('旧密码不能为空'));
    }
    const result = await AcountManageServiceImpl.getInstance().checkPssword(
      this.userInfo.id,
      value
    );
    if (!result.isTrue) {
      callback(new Error('密码不正确'));
    }
    return callback();
  }

  password(rule: any, value: any, callback: any) {
    if (!this.form.oldPassword) {
      this.form.password = '';
      return callback(new Error('先输入旧密码'));
    }
    if (!value) {
      return callback(new Error('新密码不能为空'));
    }
    if (value.length < 6 || value.length > 16) {
      return callback(new Error('请输入6-16位密码'));
    }
    return callback();
  }

  checkPassword(rule: any, value: any, callback: any) {
    if (!this.form.password) {
      this.form.confirmPassword = '';
      return callback(new Error('先输入新密码'));
    }
    if (!value) {
      return callback(new Error('旧密码不能为空'));
    }
    if (value !== this.form.password) {
      this.form.confirmPassword = '';
      callback(new Error('两次输入密码不相符'));
    }
    return callback();
  }

  submitForm(formEl: string) {
    if (!formEl) {
      return;
    }
    this.isShowLoadingBtn = true;
    (this.$refs[formEl] as any).validate((valid: any) => {
      if (valid) {
        this.modifySuccess();
      } else {
        this.isShowLoadingBtn = false;
        return false;
      }
    });
  }

  private modifySuccess() {
    AcountManageServiceImpl.getInstance()
      .modifyPassword(this.userInfo.id, this.form.password)
      .then(() => {
        this.saveAuditLog().then();
        this.closeDialog();
        CommonUtil.successMessage('修改成功');
      });
  }

  private async saveAuditLog() {
    const data = {
      actionType: actionType.setPassword.englishTitle,
      postDetail: JSON.stringify({
        id: this.userInfo.id,
        password: this.form.oldPassword
      }),
      preDetail: JSON.stringify({
        id: this.userInfo.id,
        password: this.form.password
      }),
      userId: this.userInfo.id,
      userName: this.userInfo.name
    };
    await AuditLogServiceImpl.getInstance().saveAuditLog(data);
  }
}
